module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-translate-field"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._t("default", [(!_vm.showInput) ? _c('div', {
    staticClass: "input-group-field"
  }, [_c('label', [_vm._v(_vm._s(_vm.label))])]) : _vm._e()]), _c('div', {
    staticClass: "input-group-label"
  }, [_c('ModalReveal', [_c('a', {
    attrs: {
      "slot": "trigger",
      "title": "Translate"
    },
    on: {
      "click": _vm.loadLang
    },
    slot: "trigger"
  }, [_c('mdi-icon', {
    attrs: {
      "name": "mdi-translate",
      "show-name": false
    }
  })], 1), _c('label', [_vm._v(_vm._s(_vm.label))]), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.value)
    }
  }), _c('TranslationEdit', {
    attrs: {
      "item": _vm.translations,
      "editor": _vm.editor,
      "skipDefaultLang": true,
      "editable": _vm.editable
    }
  })], 1)], 1)], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fb23999!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/TranslateField.vue
// module id = 2437
// module chunks = 1